import { useMemo, useState } from 'react';

import { FfbBankStatus } from '@/components/Shared/constants/banks-statuses';
import { BANKS_ICONS_NAMES, DictTypes } from '@/constants';
import { useWindowSize } from '@/hooks/useWindowSize';
import { useAppSelector } from '@/store';

import type { TBankOffers } from '../../../types/bank-offer.types';
import useAdditionalHelpers from './useAdditionalHelpers';

interface IProps {
  bankOffer: TBankOffers;
  hasOfferedResponse?: boolean;
}

const blueColoredStatuses = [
  FfbBankStatus.WaitingOfFinancing,
  FfbBankStatus.FinancedPledgeMissing,
  FfbBankStatus.FinancedWaitingForModificationBeforePledge,
  FfbBankStatus.OnRework
];

const useFormulateOfferItem = ({
  bankOffer: inititalBankOffer,
  hasOfferedResponse
}: IProps) => {
  const [windowWidth] = useWindowSize();
  const isMobile = windowWidth <= 860;

  const { dicts } = useAppSelector((state) => state.dict);
  const { orderApp } = useAppSelector((state) => state.newOrder);

  const [offerDetailsModal, setOfferDetailsModal] = useState<boolean | string>(
    false
  );

  const bankOffer: TBankOffers = useMemo(() => {
    const product =
      orderApp?.productInfo.product.stocksBonds?.find(
        (prod) => prod.bank_name === inititalBankOffer.bank.name
      )?.label || 'Стандарт';

    return {
      ...inititalBankOffer,
      product
    };
  }, [inititalBankOffer, orderApp?.productInfo.product.stocksBonds]);

  const { additionalProducts, getDescription } = useAdditionalHelpers({
    bankOffer,
    offerDetailsModal
  });

  const bankDict = dicts?.[DictTypes.Banks]?.getBy.name[bankOffer.bank.name];
  const bankIconName = BANKS_ICONS_NAMES[bankOffer.bank.name];
  const isCurrentResponseOffered = hasOfferedResponse && bankOffer.isOffered;

  return {
    additionalProducts,
    bankOffer,
    getDescription,
    headerIcon: bankDict?.icon || bankIconName?.icon,
    headerTitle: bankDict?.fullname || bankIconName?.name,
    isBlueColoredStatus: blueColoredStatuses.includes(
      bankOffer.status.code as FfbBankStatus
    ),
    isCurrentResponseOffered,
    isMobile,
    offerDetailsModal,
    setOfferDetailsModal
  };
};

export default useFormulateOfferItem;
